import { ClassRM } from "models/RM"
import { useAlert } from "components/Alerts/hooks"
import { useDispatch } from "react-redux"
import { alerts } from "keys"
import { reset } from "redux-form"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { createClassFetch } from "store/middlewares/testTakers.crud"
import { toast } from "react-toastify"
import { toastConfig } from "config"
import { application, pulldowns, testTakerRQ } from "store/hooks"
import { useSelector } from "react-redux"
import { mapKeys } from "lodash"
import { actions } from "store"
import { getUserDataFetch } from "store/middlewares/user.crud"
import { secretStorage } from "config"
import qc from "keys/queryClient"

const useCreateClass = () => {
    const formName = "createClass"
    const queryClient = useQueryClient()

    const setAppData = application.useSetAppData()

    const { headerFilters } = useSelector(state => state.header)

    const dispatch = useDispatch()
    const { setAlerts } = useAlert()

    const handleGrade = pulldowns.useHandleGrade()
    const { refetch: refetchClasses } = testTakerRQ.useGetSchoolClassess()

    const userData = useQuery({
        queryKey: [qc.userData],
        queryFn: async () => {
            const { data } = await getUserDataFetch()
            const user = secretStorage.getItem("user")
            secretStorage.setItem("user", { ...user, user_data: data })
            await setAppData(data)
            handleGrade(headerFilters)
            return data
        },
        enabled: false
    })

    const { mutateAsync: createClassRQ } = useMutation({
        mutationFn: createClassFetch,
        onSuccess: async () => {
            userData.refetch()

            // אנחנו סוגרים את שני סוגי הalerts אפילו שרק אחד מהם פתוח כדי למנוע את הבדיקה מי פתוח
            setAlerts(alerts.createClass, false)

            toast(" הכיתה נוצרה בהצלחה", toastConfig)
            dispatch(reset(formName))


            // const res = await refetchClasses()
            // console.log("res", res)
            // if (res.data) {
            //     pulldowns.updatePulldownStorage("classes", res.data.data)

            //     if (headerFilters?.grade) {
            //         dispatch(actions.setSchoolClasses(res.data.data))
            //     }
            // }
        }
    })

    const createClass = async (values) => {
        const classRM = new ClassRM(values)
        await createClassRQ(classRM)
    }

    return createClass
}

export default useCreateClass